import { Button, Checkbox, Form, Input, InputNumber, Select } from 'antd';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';

const nhsvEsignFlowOptions = [
  { value: 'default', label: 'Default' },
  { value: 'custom', label: 'Custom' },
];

const ItemForm = ({ form, submiting, onFinish, initialValues, name }) => {
  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'form'}
      onFinish={values => onFinish(values)}
      initialValues={initialValues}
      scrollToFirstError
    >
      <Form.Item name="name" label="Name">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="company_name" label="Company Name">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="code" label="Code">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="slug" label="Slug">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="term_condition_url" label="Term & Condition URL">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="description" label="Description">
        <Input.TextArea rows={10} />
      </Form.Item>

      <Form.Item
        name="account_opening_guideline"
        label="Account Opening Guideline"
      >
        <Input.TextArea rows={10} />
      </Form.Item>

      <Form.Item
        name="open_account_contract_form_url"
        label="Open Account Contract Form URL"
      >
        <Input placeholder="" />
      </Form.Item>

      <Form.Item
        name="is_econtract_required"
        label="E-Contract Required"
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>

      <Form.Item name="fmarket_id" label="FMarket ID">
        <InputNumber placeholder="" />
      </Form.Item>

      <Form.Item name="nhsv_code" label="NHSV Code">
        <Input placeholder="e.g. 001, 002, 003" />
      </Form.Item>

      <Form.Item name="nhsv_fund_name" label="NHSV Fund Name">
        <Input placeholder="e.g. VCAM, MAF, VCBF, KIM, VDAM" />
      </Form.Item>

      <Form.Item name="nhsv_request_esign_flow" label="NHSV Esign Flow">
        <Select allowClear placeholder="Select esign flow">
          {nhsvEsignFlowOptions.map(opt => (
            <Select.Option key={opt.value} value={opt.value}>
              {opt.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="ranking" label="Ranking">
        <InputNumber min={-1} placeholder="-1" style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ItemForm;
